import React from "react";
import { Button, SmartTooltip, TableAdv } from "../../../../components";
import { dateFormator, formatNumber, mapTableRows } from "../../../../utils";

const TableFull = () => {
  const rows = Array.from({ length: 400 }, (_, i) => ({
    id: i + 100,
    fullName: {
      firstName: `User ${i + 1}`,
      middleName: `Middle Name ${i + 1}`, // Add middleName to the row data for demonstration purposes
      lastName: `Last Name ${i + 1}`,
    },
    profilePhotoUrl: "",
    username: `user${i + 1}`,
    password: `password${i + 1}`,
    email: `user${i + 1}@example.com`,
    salary: Math.floor(Math.random() * 10000) + 1000,
    joindedDate: new Date(
      Date.now() - Math.floor(Math.random() * 100000000000),
    ).toISOString(), // need like MongoDB stores dates as BSON Date objects
    age: Math.floor(Math.random() * 50) + 18,
    company: `Company ${i + 1}`,
    department: [
      "Engineering",
      "Marketing and sales",
      "Sales",
      "HR",
      "Finance",
    ][Math.floor(Math.random() * 5)],

    info: ["", `Some Info for this id ${i + 1}`][Math.floor(Math.random() * 2)],
    countries: [
      "USA",
      "Canada",
      "Australia",
      "India",
      "United Kingdom",
      "Germany",
      "France",
      "Spain",
      "Italy",
      "Brazil",
    ][Math.floor(Math.random() * 10)],
    gender: [1, 2, 3, 4][Math.floor(Math.random() * 4)],

    phone: `+1 (${Math.floor(Math.random() * 1000)}) ${Math.floor(
      Math.random() * 1000,
    )}-${Math.floor(Math.random() * 10000)}`,
    address: `123 Main St, City ${i + 1}, State ${i + 1}, Country ${i + 1}`,
  }));

  const columns = [
    {
      key: "fullName",
      labelKey: "fullName",
      label: "Employee Name",
      render: (row) => {
        return (
          <div className="inline-block">
            <SmartTooltip
              tooltipPosition="bottom"
              description={`${row.fullName.firstName}-${row.fullName.middleName}-${row.fullName.lastName}`}
            >
              <div className="line-clamp-1">
                {row.fullName.firstName}-{row.fullName.middleName}-
                {row.fullName.lastName}
                {row.fullName.firstName}-{row.fullName.middleName}-
                {row.fullName.lastName}
              </div>
            </SmartTooltip>
          </div>
        );
      },
      width: "flex-1", // Using Tailwind class for width
    },

    {
      key: "joindedDate",
      label: "Joinded Date",
      render: (row) => {
        return (
          <div className="whitespace-nowrap">
            {dateFormator(row.joindedDate)}
          </div>
        );
      },
    },
    {
      key: "email",
      label: "Email Address",
    },
    {
      key: "age",
      label: "Age",
      getRowClass: (row) => {
        // Example conditions for row styling
        if (row.status === "Inactive") {
          return "bg-red-100 !hover:bg-red-200";
        } else if (row.status === "Pending") {
          return "bg-yellow-50 hover:bg-yellow-100";
        } else if (row.age < 50 && row.age > 40) {
          return "bg-blue-50 hover:bg-blue-100 border-l-4 border-blue-500";
        } else if (row.salery > 8000) {
          return "bg-green-50 hover:bg-green-100 font-semibold";
        }
        return ""; // Default case
      },
    },
    {
      key: "department",
      label: "Department",

      render: (row) => {
        return <div className="whitespace-nowrap">{row.department}</div>;
      },
    },

    {
      key: "countries",
      label: "Countries",
      // No width specified, will use default flex: 1
    },

    {
      key: "phone",
      label: "Phone",
      render: (row) => {
        return <div className="whitespace-nowrap">{row.phone}</div>;
      },
      // hide: true,
    },
    {
      key: "address",
      label: "Address",
      //width: "w-[350px]",
      render: (row) => {
        return <div className="whitespace-nowrap">{row.address}</div>;
      },
      // hide: true,
    },

    {
      key: "salary",
      label: "Salary",
      //total: true,
      totalRender: (totalValue, totals) => {
        //console.log("totals", totals);
        // Example: Add a currency symbol and custom formatting
        return <div className="text-left">$ {formatNumber(totalValue)}</div>;
      },
    },
    {
      key: "salaryNew",
      label: "Salary2",
      width: "150px",
      columnMenu: false,
      // hide: true,
      render: (row) => {
        return <div className="whitespace-nowrap">${row.salary}</div>;
      },
      //total: true,
      totalRender: (totalValue, totals) => {
        //console.log("totals", totals);
        // Example: Add a currency symbol and custom formatting
        return <div>Total : $ {formatNumber(totalValue)}</div>;
      },
    },
    {
      key: "",
      label: "Action",
      render: (row) => {
        return (
          <div className="flex gap-2">
            <Button
              type="icon"
              icon={"edit"}
              variant="text"
              size="xs-sm"
              color="info"
              onClick={() => {
                console.log("edit", row);
              }}
            />
            <Button
              type="icon"
              icon={"delete"}
              variant="text"
              size="xs-sm"
              color="danger"
              onClick={() => {
                console.log("delete", row);
              }}
            />
          </div>
        );
      },
    },
  ];

  const mappedRows = mapTableRows(rows, columns);
  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <TableAdv
        columns={columns}
        rows={mappedRows}
        tableId={"newTableForTesting-TableFullScreen"}
        toolbarRight={{
          search: true,
          filter: true,

          fullScreen: true,
        }}
      />
    </div>
  );
};

export default TableFull;
